import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux';

export const M_Detail = ({ onClose, closeOnEscape = true, closeOnBackdrop = true, selectedItem }) => {

    // ============ [ GESTION DE MODAL ] ============ //
    const [isVisible, setIsVisible] = useState(false);
    const dialogRef = useRef(null);

    useEffect(() => {
        setTimeout(() => setIsVisible(true), 10);
    }, []);

    // Cerrar con Escape si está permitido
    useEffect(() => {
        if (!closeOnEscape) return;

        const handleKeyDown = (e) => {
            if (e.key === "Escape") handleClose();
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [closeOnEscape]);

    // Cerrar con clic fuera si está permitido
    const handleBackdropClick = (e) => {
        if (!closeOnBackdrop) return;
        if (dialogRef.current && !dialogRef.current.contains(e.target)) {
            handleClose();
        }
    };

    // Animación al cerrar
    const handleClose = () => {
        setIsVisible(false);
        setTimeout(onClose, 250); // espera la animación
    };
    //========================================================================================================

    const { idCustomer, order } = useSelector(state => state.customerDetail);
    let detail = order[0]; let servicios = detail?.SERVICIOS; let refacciones = detail?.REFACCIONES;


    let subtotal_servicios = 0;
    servicios?.forEach(item => {
        // console.log(item.ID);
        if (item.AUTORIZO == 1 && item.ESTADO == 1) {
            subtotal_servicios = subtotal_servicios + Number(item.COSTO);
        }
    });

    let subtotal_refacciones = 0;
    refacciones?.forEach(item => {
        if (item.ESTADO != 0 && item.ESTADO != 6) {
            subtotal_refacciones = subtotal_refacciones + Number(item.COSTO_CLIENTE);
        }

    })

    let subtotal = subtotal_refacciones + subtotal_servicios;


    return (
        <div className={`modal d-block custom-backdrop ${isVisible ? "show" : ""}`} onClick={handleBackdropClick}>
            <div ref={dialogRef} className={`modal-dialog custom-modal-animate modal-xl ${isVisible ? "show" : ""}`}>
                <div className="modal-content" style={{ backgroundColor: "#ffffff" }}>
                    <div className="modal-header">
                        <h5 className="modal-title fw-bold">Detalle de la Orden: {selectedItem}</h5>
                        <button type="button" className="btn-close" onClick={() => { onClose() }}></button>
                    </div>

                    <div className="modal-body row">

                        <div className='col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3'>
                            <h6 className="fw-bold me-2 border-0">Cliente: {detail?.CLIENTE_ID} </h6>
                            <hr className='my-0' />
                            <div className="mb-1 mt-1">
                                <label className="form-label">Datos del cliente </label>
                                <input type="text" className="form-control" value={detail?.NOMBRE} disabled />
                            </div>
                            <div className="mb-1">
                                <label className="form-label">Telefono:</label>
                                <input type="text" className="form-control" value={detail?.TELEFONO} disabled />
                            </div>
                            <div className="mb-1">
                                <label className="form-label">Celular:</label>
                                <input type="text" className="form-control" value={detail?.CELULAR} disabled />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Correo electronico:</label>
                                <input type="text" className="form-control" value={detail?.EMAIL} disabled />
                            </div>
                            <h6 className="fw-bold me-2 border-0">Datos del Equipo </h6>
                            <hr className='my-0' />
                            <div className="mb-2 mt-1">
                                <label className="form-label">Equipo:</label>
                                <input type="text" className="form-control" value={detail?.EQUIPO} disabled />
                            </div>
                            <div className="mb-2">
                                <label className="form-label">Sistema Operativo:</label>
                                <input type="text" className="form-control" value={detail?.SIS_OP} disabled />
                            </div>
                        </div>

                        <div className='col-12 col-sm-12 col-md-9 col-lg-9 col-xl-9 col-xxl-9'>
                            <div className='row'>
                                <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6'>
                                    <div className=" mb-2">
                                        <label className="form-label text-black fw-bold">Descripción de la falla(s):</label>
                                        <textarea className="form-control" rows="4" disabled defaultValue={detail?.DESCRIPCION_FALLA}></textarea>
                                    </div>
                                </div>
                                <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6'>
                                    <div className=" mb-2">
                                        <label className="form-label text-dark fw-bold">Diagnostico:</label>
                                        <textarea className="form-control" rows="4" disabled defaultValue={detail?.DIAGNOSTICO || ""}></textarea>
                                    </div>
                                </div>

                                <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12'>
                                    <h5 className="card-title fw-bold text-dark mb-2 mt-3">Servicios </h5>
                                    <div className="row">
                                        <div className="table-responsive mt-1 table-scrollbar-6">
                                            <table className="table table-sm table-striped table-hover">
                                                <thead>
                                                    <tr>
                                                        <th scope="col" className='th-sticky'>#</th>
                                                        <th scope="col" className='th-sticky'>SERVICIO</th>
                                                        <th scope="col" className="text-center th-sticky">AUTORIZADO</th>
                                                        <th scope="col" className="text-center th-sticky">REALIZADO</th>
                                                        <th scope="col" className="text-end th-sticky">COSTO</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        servicios?.length === 0 ?
                                                            <>
                                                                <tr>
                                                                    <td scope="row" colSpan={5}> No se han encontrado datos.</td>

                                                                </tr>
                                                            </> :
                                                            servicios?.map((item, index) => (
                                                                <tr key={index} className={item.AUTORIZO != 1 ? 'table-warning' : ''}>
                                                                    <td>{index + 1}</td>
                                                                    <td>{item.NOMBRE}</td>
                                                                    <td className="text-center">
                                                                        {
                                                                            item.AUTORIZO == 1 ? <>
                                                                                <img src="./assets/images/indicators/check.png" width="28" height="28" /></> :
                                                                                <><img src="./assets/images/indicators/close.png" width="28" height="28" /></>
                                                                        }
                                                                    </td>
                                                                    <td className="text-center" >
                                                                        {
                                                                            item.ESTADO == 1 ? <>
                                                                                <img src="./assets/images/indicators/check.png" width="28" height="28" /></> :
                                                                                <><img src="./assets/images/indicators/close.png" width="28" height="28" /></>
                                                                        }
                                                                    </td>
                                                                    <td className="text-end">{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(item.COSTO)}</td>

                                                                </tr>
                                                            ))
                                                    }
                                                </tbody>
                                                <tfoot>
                                                    <tr>
                                                        <td colSpan="4" className="text-end fw-bold">Subtotal:</td>
                                                        <td className="fw-bold text-end">{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(subtotal_servicios)}</td>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                                <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12'>
                                    <h5 className="card-title fw-bold text-dark mb-2 mt-3">Refacciones </h5>
                                    <div className="table-responsive mt-1 table-scrollbar-6">
                                        <table className="table table-sm table-striped table-hover">
                                            <thead>
                                                <tr>
                                                    <th scope="col" className='th-sticky'>#</th>
                                                    <th scope="col" className='th-sticky'>REFACCIÓN</th>
                                                    <th scope="col" className="text-end th-sticky">COSTO ($)</th>
                                                    <th scope="col" className="text-end th-sticky">C. CLIENTE. ($)</th>
                                                    <th scope="col" className="text-center th-sticky">ESTADO</th>
                                                    {/* <th scope="col" className="text-center th-sticky">EVIDENCIAS</th>
                                                    <th scope="col" className="text-center th-sticky">ACCIONES</th> */}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    refacciones?.length === 0 ?
                                                        <>
                                                            <tr>
                                                                <td scope="row" colSpan={5}> No se han encontrado datos.</td>

                                                            </tr>
                                                        </> :
                                                        refacciones?.map((item, index) => (
                                                            <tr key={index}>
                                                                <td>{index + 1}</td>
                                                                <td>{item.REFACCION}</td>
                                                                <td className="text-end">{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(item.COSTO_HDL)}</td>
                                                                <td className="text-end">{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(item.COSTO_CLIENTE)}</td>
                                                                <td className="text-center">

                                                                    <select className="form-select" aria-label="Default select example" defaultValue={item.ESTADO} disabled>
                                                                        {/* <option >Open this select menu</option> */}
                                                                        <option value={0}>Solicitada</option>
                                                                        <option value={1}>Aprobada</option>
                                                                        <option value={2}>Comprada, en espera</option>
                                                                        <option value={3}>Llego</option>
                                                                        <option value={4}>Disponible</option>
                                                                        <option value={5}>Instalada</option>
                                                                        <option value={6}>Rechazo Cliente</option>
                                                                    </select>
                                                                </td>

                                                            </tr>
                                                        ))
                                                }
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <td colSpan={3} className="text-end fw-bold">Subtotal:</td>
                                                    <td className="fw-bold text-end">{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(subtotal_refacciones)}</td>
                                                    <td></td>
                                                  
                                                </tr>
                                            </tfoot>

                                        </table>
                                    </div>
                                </div>

                                <div className='text-end'>
                                    <h5 className="mt-4">
                                        SUBTOTAL DE SERVICIOS Y REFACCIONES:  <span className="fw-bold me-2">{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(subtotal)}</span>
                                    </h5>
                                </div>


                            </div>
                        </div>


                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-outline-dark" onClick={() => { onClose() }}>
                            Cerrar
                        </button>

                    </div>

                </div>
            </div>
        </div>
    )
}
